import React from 'react'
import styles from './ButtonLogin.module.css'


const ButtonLogin = ({
    title, 
    style,
    onClick,
    isLeftIcon,
    LeftIcon,
}) => {
    return (
        <div 
            className={styles.button} 
            style={style}
            onClick={onClick}>
            { isLeftIcon ?
                <LeftIcon style={{margin: '0 16px 0 0 '}}/>
                : null
            }
            {title}
        </div>
    )
}

export default ButtonLogin
